import _ from "underscore";
import { is_uuid } from "../../lib/uuid";

const partitionBySize =  (items, size) => {
  const cloned_keys = _.keys(items).filter(key => is_uuid(key));
  const normal_keys = _.keys(items).filter(key => !is_uuid(key));

  let chunkedKeys = _.chunk(cloned_keys.concat(normal_keys), size);
  
  return _.map(chunkedKeys, row => {
      return _.map(row, column => {
          return items[column];
      })
  })
}

export { partitionBySize };
